import React from "react";

import { Tooltip } from "@mui/material";
import { MdAudioFile, MdImage } from "react-icons/md";

import { BaseCard } from "components/BaseCard";
import { TitleSubTitleLabel } from "components/TitleSubTitleLabel";

import downloadIcon from "assets/hearingDetails/download.svg";
import fileIcon from "assets/svg/FileIcon.svg";
import videoIcon from "assets/svg/VideoIcon.svg";

import { IButtonClickCard } from "./interface";
import {
  Container,
  RightContainer,
  LeftSide,
  IconButtonClickCard,
  TextButtonClickCard,
  InfoAreaButtonClickCard,
  CircleButtonClickCard,
} from "./styles";

export const ButtonClickCard: React.FC<IButtonClickCard> = ({
  id,
  title,
  subTitle,
  selected = false,
  disabled = false,
  tooltipMessagem,
  typeButton,
  typeIcon,
  onClick,
}) => {
  const iconSelect = () => {
    switch (typeIcon) {
      case "video":
        return <img src={videoIcon} style={{ height: "40px", width: "40px" }} />;
      case "audio":
        return <MdAudioFile size={40} color="#7887A9" />;
      case "photo":
        return <MdImage size={40} color="#7887A9" />;
      case "document":
      case "file":
      default:
        return <img src={fileIcon} style={{ height: "40px", width: "40px" }} />;
    }
  };
  const handleClick = disabled ? undefined : onClick;

  return (
    <BaseCard selected={selected} disabled={disabled}>
      <Container data-testid={id}>
        <LeftSide>
          <IconButtonClickCard>{iconSelect()}</IconButtonClickCard>
          <TextButtonClickCard>
            <TitleSubTitleLabel
              childrenTitle={title}
              childrenSubTitle={subTitle}
              marginTop="4px"
            />
          </TextButtonClickCard>
        </LeftSide>
        <RightContainer>
          <Tooltip title={tooltipMessagem} placement="left">
            {typeButton === "radio" ? (
              <CircleButtonClickCard
                disabled={disabled}
                onClick={handleClick}
              />
            ) : (
              <InfoAreaButtonClickCard
                disabled={disabled}
                onClick={handleClick}
              >
                <img src={downloadIcon} />
              </InfoAreaButtonClickCard>
            )}
          </Tooltip>
        </RightContainer>
      </Container>
    </BaseCard>
  );
};
